/* 🤖 this file was generated by svg-to-ts */
export const myIconChevronBack: {
  name: 'chevron_back';
  data: string;
} = {
  name: 'chevron_back',
  data: `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M328 112 184 256l144 144"/></svg>`,
};
